module.exports = __webpack_public_path__ + "assets/img/teacher (1).9bb2fa76.png";